<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .outer-wrapper {
    padding: utils.in_rem(32px);

    .icons {
      display: grid;
      grid-template-columns: repeat(2, 1fr); /* Two columns */
      grid-template-rows: repeat(2, auto); /* Two rows */
      gap: utils.in_rem(4px);
    }

    .text {
      @include colors.color(black_50);
      @include mixins.body2();
    }
  }
</style>

<script>
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import NoData from "@sourcewhale/shared/svelte-design-system/components/atoms/NoData.svelte";

  export let selectedView = "pastActivity";

  const messageMap = {
    pastActivity: "No history available",
    scheduledActivity: "No scheduled activity",
  };
</script>

<div class="outer-wrapper">
  <NoData>
    <div slot="icons" class="icons">
      <IconScale
        backgroundColor="interfaceSwGrey_10"
        color="interfaceSwGrey_20"
        class="fa-solid fa-envelope-open"
        size="xl"
      />
      <IconScale
        backgroundColor="interfaceSwGrey_10"
        color="interfaceSwGrey_20"
        class="fa-solid fa-phone"
        size="xl"
      />
      <IconScale
        backgroundColor="interfaceSwGrey_10"
        color="interfaceSwGrey_20"
        class="fa-solid fa-reply"
        size="xl"
      />
      <IconScale
        backgroundColor="interfaceSwGrey_10"
        color="interfaceSwGrey_20"
        class="fa-solid fa-voicemail"
        size="xl"
      />
    </div>
    <div slot="text" class="text">{messageMap[selectedView]}</div>
  </NoData>
</div>
